import { lineString as turfLineString, length as turfLength, along as turfAlong } from "@turf/turf";

export default function pointsForLineString(startLat, startLon, endLat, endLon) {
  const lineString = turfLineString([[startLon, startLat], [endLon, endLat]]);
  const length = turfLength(lineString, { units: "meters" });
  const intervalLength = 100;
  const numberOfIntervals = length / intervalLength;
  let points: number[][] = [];
  points.push(lineString.geometry.coordinates[0]);
  for (let i = 0; i < numberOfIntervals; i++) {
    const point = turfAlong(lineString, i * intervalLength, {
      units: "meters",
    });
    points.push(point.geometry.coordinates);
  }
  points.push(lineString.geometry.coordinates[1]);
  return points;
}

export function pointsOnLineString(coords, intervalLength = 500) {
  const lineString = turfLineString(coords)
  const length = turfLength(lineString, { units: "meters" });
  const numberOfIntervals = Math.floor(length / intervalLength)
  let points: number[][] = [];
  for (let i = 0; i < numberOfIntervals; i++) {
    const point = turfAlong(lineString, i * intervalLength, {
      units: "meters",
    });
    points.push(point.geometry.coordinates);
  }
  points.push(lineString.geometry.coordinates[lineString.geometry.coordinates.length - 1]);
  return points;
}
